// extracted by mini-css-extract-plugin
export default {"addLocationContainer":"style_addLocationContainer__6FkZ7"};